module.exports = __webpack_public_path__ + "static/media/camera_white.6bee6090.svg";